import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d2efd56"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "loading-spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "ms-2 d-flex align-center"
}

import { withDefaults } from 'vue';
import LoadingIcon from './icons/LoadingIcon.vue';
import { watch } from 'vue';

interface IProps {
  classes?: string;
  text?: string;
  background?: string;
  color?: string;
  outlineColor?: string;
  hoverColor?: string;
  prependIcon?: boolean;
  outlined?: boolean;
  appendIcon?: boolean;
  disabled?: boolean;
  noHover?: boolean;
  buttonWidth?: string;
  buttonHeight?: string;
  selected?: boolean | null;
  isLoading?: boolean;
  useMargin?: boolean
}



export default /*#__PURE__*/_defineComponent({
  __name: 'AtomButton',
  props: {
    classes: {},
    text: {},
    background: {},
    color: {},
    outlineColor: {},
    hoverColor: {},
    prependIcon: { type: Boolean },
    outlined: { type: Boolean },
    appendIcon: { type: Boolean },
    disabled: { type: Boolean, default: false },
    noHover: { type: Boolean, default: false },
    buttonWidth: {},
    buttonHeight: {},
    selected: { type: [Boolean, null], default: null },
    isLoading: { type: Boolean, default: false },
    useMargin: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props;

let classButton = `
  color-button d-flex justify-center align-center
  ${!props.noHover && !props.disabled ? 'isHover' : ''} 
  ${props.outlined ? 'btn-outlined hover-outline' : ''} 
  ${props.outlineColor || ''} 
  ${props.classes || ''} 
  ${props.selected === true ? 'selected' : props.selected === false ? 'notSelected' : ''}
`;

watch(() => props.selected, () => {
  classButton = `
  color-button d-flex justify-center align-center
  ${!props.noHover && !props.disabled ? 'isHover' : ''} 
  ${props.outlined ? 'btn-outlined hover-outline' : ''} 
  ${props.outlineColor || ''} 
  ${props.classes || ''} 
  ${props.selected === true ? 'selected' : props.selected === false ? 'notSelected' : ''}
`;
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    disabled: props.disabled,
    class: _normalizeClass(_unref(classButton)),
    style: _normalizeStyle([{ width: props.buttonWidth, height: props.buttonHeight }, {}])
  }, [
    (props.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(LoadingIcon, { class: "rotating-svg" })
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (props.prependIcon)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["d-flex align-center", _ctx.useMargin ? 'me-2' : ''])
              }, [
                _renderSlot(_ctx.$slots, "prependIcon")
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("span", {
            style: _normalizeStyle({ color: _ctx.color ? _ctx.color : '' })
          }, _toDisplayString(props.text), 5),
          _renderSlot(_ctx.$slots, "default"),
          (props.appendIcon)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "appendIcon")
              ]))
            : _createCommentVNode("", true)
        ], 64))
  ], 14, _hoisted_1))
}
}

})